import {VirtualTeamsConstant as constants} from '../../../_constants/VirtualTeams/VirtualTeams.constants';

const initialState = { team_create_loading : true, team_create_data: {}, team_create_error: false };

export function virtualTeamCreate(state = initialState, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_TEAM_CREATE_LOADING:
            return {
                team_create_loading: true,
                team_create_data: {},
                team_create_error: false
            };
        case constants.VIRTUAL_TEAM_CREATE_DATA:
            return {
                team_create_loading: false,
                team_create_data: action.virtual_create,
                team_create_error: false
            };
        case constants.VIRTUAL_TEAM_CREATE_ERROR:
            return {
                team_create_loading: false,
                team_create_data: {},
                team_create_error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/VirtualTeams/VirtualTeamCreate/VirtualTeamCreate.reducer.js